import { PixKeyType } from "~/application/types";

export const sanitizePixKey = (key?: string | null, type?: PixKeyType | null) => {
  if (!key) return key;
  if (type === PixKeyType.CPF || type === PixKeyType.CNPJ || type === PixKeyType.PHONE) {
    return key.replace(/\D/g, "");
  }
  return key;
};

export const PIX_TYPE_LABEL_MAP: Record<PixKeyType, string> = {
  [PixKeyType.CPF]: "CPF",
  [PixKeyType.CNPJ]: "CNPJ",
  [PixKeyType.PHONE]: "Celular",
  [PixKeyType.EMAIL]: "E-mail",
  [PixKeyType.EVP]: "Chave Aleatória",
};
